<template>
  <div>
    <div class="row row-gap">
      <div class="col-6 col-md-3"
           v-if="Object.keys(galleryPreviews).length > 0"
           v-for="(img, key) in galleryPreviews"
           :key="'preview_' + key">
        <!--        тут можно поменять на img.origin, чтобы выводить оригинальные картинки-->
        <div class="gallery-item">
          <img :src="img.origin" :alt="img.alt ? img.alt : img.id"
               @click="setCurrentImg(key)"
               style="cursor: pointer;">
        </div>
      </div>
    </div>
    
    
    <gallery-modal v-if="isShowModal"
                   :img="currentImg.origin"
                   @close="isShowModal = false"
                   @prev="prev"
                   @next="next"></gallery-modal>
  </div>
</template>

<script>
  import GalleryModal from "./GalleryModal";
    export default {
        name: 'gallery-preview',
        components: {
          GalleryModal,
        },
        data() {
            return {
                galleryPreviews,
                Lang,
                key: 0,
                currentImg: '',
                isShowModal: false,
                length: 0,
            }
        },
        methods: {
            setCurrentImg(key) {
                this.key = key;
                this.currentImg = this.galleryPreviews[key];
                this.isShowModal = true;
            },
            prev() {
                if (this.key > 0) {
                    this.key = this.key - 1;
                } else {
                    this.key = this.length - 1;
                }
                this.currentImg = this.galleryPreviews[this.key];
            },
            next() {
                if (this.key < this.length - 1) {
                    this.key = this.key + 1;
                } else {
                    this.key = 0;
                }
                this.currentImg = this.galleryPreviews[this.key];
            }
        },
        mounted() {
            if (this.galleryPreviews && this.galleryPreviews.length > 0) {
                this.length = this.galleryPreviews.length;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/elements/GalleryPreview.vue